import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';

const CheckoutLayout = ({ children, sidebar, className = '' }) => (
  <div className={`checkout-page ${className}`.trim()}>
    <Container fluid className="checkout-page__container">
      <Row className="checkout-page__row justify-content-center">
        <Col lg={8} xl={8} className="checkout-page__main">
          {children}
        </Col>
        {sidebar && (
          <Col lg={4} xl={3} className="checkout-page__sidebar">
            {sidebar}
          </Col>
        )}
      </Row>
    </Container>
  </div>
);

CheckoutLayout.propTypes = {
  children: PropTypes.node.isRequired,
  sidebar: PropTypes.node,
  className: PropTypes.string,
};

export default CheckoutLayout;
